var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4136 6.81641C25.604 6.66504 25.8872 6.80664 25.8872 7.0459V17.0312C25.8872 18.3252 24.8374 19.375 23.5435 19.375H3.23096C1.93701 19.375 0.887207 18.3252 0.887207 17.0312V7.05078C0.887207 6.80664 1.16553 6.66992 1.36084 6.82129C2.45459 7.6709 3.90479 8.75 8.88525 12.3682C9.91553 13.1201 11.6538 14.7021 13.3872 14.6924C15.1304 14.707 16.9028 13.0908 17.894 12.3682C22.8745 8.75 24.3198 7.66602 25.4136 6.81641ZM13.3872 13.125C14.52 13.1445 16.1509 11.6992 16.9712 11.1035C23.4507 6.40137 23.9438 5.99121 25.438 4.81934C25.7212 4.59961 25.8872 4.25781 25.8872 3.89648V2.96875C25.8872 1.6748 24.8374 0.625 23.5435 0.625H3.23096C1.93701 0.625 0.887207 1.6748 0.887207 2.96875V3.89648C0.887207 4.25781 1.05322 4.59473 1.33643 4.81934C2.83057 5.98633 3.32373 6.40137 9.80322 11.1035C10.6235 11.6992 12.2544 13.1445 13.3872 13.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3fdd29658d4c7035eda79411a377057d.svg";
export { ForwardRef as ReactComponent };